<div class="modal" id="addModal" tabindex="-1">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<table class="table table-striped table-hover">
					<thead>
						<tr>
							<th>Pojazd</th>
							<th>Wolne</th>
							<th>Załoga</th>
							<th>Ilość Miejsc</th>
							<th>Zajęte</th>
							<th></th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr [ngClass]="{ 'bg-danger': item.selected }" *ngFor="let item of vehicles">
							<td>{{ item.name }}</td>
							<td>
								{{ item.seats - item.occupied - item.crew }}
							</td>
							<td>
								<input type="number" class="form-control" name="crew" [(ngModel)]="item.crew" min="0" />
							</td>
							<td>{{ item.seats }}</td>
							<td>{{ item.occupied }}</td>
							<td>
								<button class="btn btn-success" (click)="selectVehicle(item)">
									<i class="fas fa-check"></i> Wybierz
								</button>
							</td>
							<td>
								<button
									class="btn btn-warning"
									(click)="vehicleRemove(item)"
									*ngIf="item.occupied === 0"
								>
									<i class="fas fa-times"></i> Usuń
								</button>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="input-group mb-3">
					<select class="form-control" name="vehicleToAdd" id="vehicleToAdd" [(ngModel)]="vehicleToAdd">
						<option [value]="item.id" *ngFor="let item of vehiclesAll">
							{{ item.name }}
						</option>
					</select>
					<button class="btn btn-primary" type="button" (click)="vehicleAdd(vehicleToAdd)">
						Dodaj pojazd
					</button>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Zamknij</button>
			</div>
		</div>
	</div>
</div>
